import { ARTICLE_POLICY_VERSION, allegationCapEnabled } from './adverseMediaArticlePolicy';

const ratings = ['high', 'medium', 'low'];

// Supplement the article's review status with a rating where the saved,
// party-linked findings support one. Do not mutate the saved assessment.
export function articleConcernRating(assessment, concern) {
  if (ratings.includes(concern)) return concern;
  if (concern !== 'review' || assessment?.assessmentVersion !== ARTICLE_POLICY_VERSION
    || assessment.articleUsable === false || assessment.involvement !== 'direct'
    || !Number.isFinite(assessment.nameAssessment?.score) || assessment.nameAssessment.score <= 0
    || !['strong', 'moderate'].includes(assessment.nameAssessment.strength)) return null;

  const findings = (assessment.findings || []).filter(finding => finding.involvement === 'direct');
  const levels = findings.map(finding => {
    if (!ratings.includes(finding.severity)) return null;
    if (finding.severity !== 'high') return finding.severity;
    if (['dismissed', 'acquitted'].includes(finding.caseStatus)
      || assessment.nameAssessment.strength === 'moderate'
      || ['low', 'medium'].includes(assessment.sourceQuality)
      || (finding.caseStatus === 'allegation' && allegationCapEnabled(assessment.concernPolicy))) return 'medium';
    // An unclassified source is not evidence that the source is unreliable.
    return 'high';
  });
  const rating = ratings.find(level => levels.includes(level)) || null;
  // An unclear direct finding must not be concealed behind a reassuring Low.
  return rating === 'low' && levels.includes(null) ? null : rating;
}
